import { cn } from "@/utils/cn";

interface DashboardCardProps {
  title: string;
  count: number;
  label: string;
  color: "amber" | "blue" | "green" | "red";
  onClick?: () => void;
}

const colorMap = {
  amber: "border-amber-200 bg-amber-50 text-amber-700",
  blue: "border-blue-200 bg-blue-50 text-blue-700",
  green: "border-green-200 bg-green-50 text-green-700",
  red: "border-red-200 bg-red-50 text-red-700",
};

const countColorMap = {
  amber: "text-amber-600",
  blue: "text-blue-600",
  green: "text-green-600",
  red: "text-red-600",
};

const DashboardCard = ({
  title,
  count,
  label,
  color,
  onClick,
}: DashboardCardProps) => {
  const isEmpty = count === 0;

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex flex-col items-start gap-2 rounded-xl border p-5 text-left transition-all duration-150 hover:-translate-y-px hover:shadow-md",
        isEmpty ? "border-gray-200 bg-gray-50 text-gray-400" : colorMap[color],
      )}
    >
      <span className="text-sm font-medium opacity-80">{title}</span>
      <span
        className={cn(
          "text-3xl font-bold",
          isEmpty ? "text-gray-300" : countColorMap[color],
        )}
      >
        {count}
      </span>
      <span className="text-xs opacity-60">{label}</span>
    </button>
  );
};

export default DashboardCard;
